export default {
      id: "arrow-up-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }